import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

interface Vendor {
    id: number;
    name: string;
    phone?: string;
    balance?: number;
}

function VendorsIndex() {
    const [vendors, setVendors] = useState<Vendor[]>([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');

    useEffect(() => {
        loadVendors();
    }, [search]);

    const loadVendors = async () => {
        try {
            setLoading(true);
            const response = await api.get('/vendors', { q: search });
            if (response.success) {
                // The API returns { data: [...], meta: {...} } OR { vendors: [...] }
                setVendors(Array.isArray(response.data) ? response.data : (response.data.vendors || []));
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div className="mt-16 p-8">Loading...</div>;

    return (
        <div className="mt-16">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold text-slate-800">Vendors</h1>
                <Link to="/vendors/new" className="px-4 py-2.5 bg-indigo-600 text-white rounded-xl font-medium hover:bg-indigo-700">
                    + New Vendor
                </Link>
            </div>

            <div className="mb-6">
                <input
                    type="text"
                    placeholder="Search vendors..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="w-full px-4 py-2.5 rounded-xl border border-slate-200"
                />
            </div>

            <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
                <table className="w-full">
                    <thead className="bg-slate-50 border-b border-slate-200">
                        <tr>
                            <th className="text-left py-3 px-4 text-sm font-semibold text-slate-700">Name</th>
                            <th className="text-left py-3 px-4 text-sm font-semibold text-slate-700">Phone</th>
                            <th className="text-right py-3 px-4 text-sm font-semibold text-slate-700">Balance</th>
                            <th className="text-right py-3 px-4 text-sm font-semibold text-slate-700">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {vendors.map((vendor) => (
                            <tr key={vendor.id} className="border-b border-slate-100 hover:bg-slate-50">
                                <td className="py-3 px-4 font-medium text-slate-800">{vendor.name}</td>
                                <td className="py-3 px-4 text-slate-700">{vendor.phone || '-'}</td>
                                <td className="py-3 px-4 text-right text-slate-700">₹{vendor.balance?.toLocaleString()}</td>
                                <td className="py-3 px-4 text-right">
                                    <Link to={`/vendors/${vendor.id}`} className="px-3 py-1.5 text-sm text-indigo-600 hover:bg-indigo-50 rounded-lg">
                                        View
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default VendorsIndex;
